"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postprocessDom = void 0;
const merge_adjacent_unicode_text_nodes_1 = require("./merge-adjacent-unicode-text-nodes");
const add_selectable_node_1 = require("./add-selectable-node");
function postprocessDom(dom) {
    dom = (0, merge_adjacent_unicode_text_nodes_1.mergeAdjacentUnicodeTextNodes)(dom);
    dom = (0, add_selectable_node_1.addSelectableNode)(dom);
    return dom;
}
exports.postprocessDom = postprocessDom;
